<div class="flex h-full flex-col focus-visible:outline-0" tabindex="0">
  <div class="flex-1 overflow-hidden">
    <div class="h-full">
      <ion-content #chat>
        <div class="flex h-full flex-col items-center gap-2.5 p-4">
          @if (state.isLoading) {
            <div class="flex h-full w-full items-center justify-center">
              <dojo-loader />
            </div>
          } @else {
            @if (state.chatMessages && state.chatMessages.length > 0) {
              @for (item of state.chatMessages; track item.id; let last = $last) {
                <dojo-image-chat-message [message]="item" class="w-full" [class.pb-4]="last" />
              }

              @if (state.isResponseLoading) {
                <dojo-loader />
              }
            }
          }
        </div>
      </ion-content>
    </div>
  </div>

  <div class="bg-neutral-0 w-full p-4 pt-0">
    <dojo-chat-input
      [inputDisabled]="state.isInputDisabled"
      [isChatCreated]="state.isChatCreated"
      (submitMessage)="sendMessage($event)"
      (restartChat)="restartChat()"
      class="w-full"
    />
  </div>
</div>
